import api from '../utils/api';

// Fetch all Digital Resources
export const getDigitalResources = async (headers) => {
  try {
    const response = await api.get('/api/digital-resources/digital-resources', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching digital resources:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific Digital Resource by ID
export const getDigitalResourceById = async (id, headers) => {
  try {
    const response = await api.get(`/api/digital-resources/digital-resources/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error fetching digital resource with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new Digital Resource
export const createDigitalResource = async (digitalResourceData, headers) => {
  try {
    const response = await api.post('/api/digital-resources/digital-resources', digitalResourceData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating digital resource:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing Digital Resource
export const updateDigitalResource = async (id, digitalResourceData, headers) => {
  try {
    const response = await api.put(`/api/digital-resources/digital-resources/${id}`, digitalResourceData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating digital resource with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a Digital Resource
export const deleteDigitalResource = async (id, headers) => {
  try {
    const response = await api.delete(`/api/digital-resources/digital-resources/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting digital resource with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
